import { BaseModel } from "model/BaseModel";
import ClassificacaoRequisito from "../ClassificacaoRequisito";
import { OpcaoRespostaRequisito } from "./OpcaoRespostaRequisito";

export default class RequisitoAuditoria implements BaseModel {

    id: number;
    codigo: string | null;
    nome: string;
    descricao: string;
    permiteResposta: boolean;
    respostaObrigatoria: boolean;
    classificacaoRequisito: ClassificacaoRequisito | null;
    opcoesResposta: OpcaoRespostaRequisito[] = [];
    tipoResposta: string;

    constructor(
        id = 0,
        codigo = null,
        nome = '',
        descricao = '',
        permiteResposta = false,
        respostaObrigatoria = false,
        classificacaoRequisito = null,
        tipoResposta = "TEXTO"
    ) {
        this.id = id;
        this.codigo = codigo;
        this.nome = nome;
        this.descricao = descricao;
        this.permiteResposta = permiteResposta;
        this.respostaObrigatoria = respostaObrigatoria;
        this.classificacaoRequisito = classificacaoRequisito;
        this.tipoResposta = tipoResposta;
    }
}
